import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import SecureLS from 'secure-ls';
import MessageInfoBox from '../../components/other/MessageInfoBox';
import styles from '../../css/XiaomiEventLogin.module.css';
import { axiosinstance } from '../../configAxios';
import { happeningXiaomiEvent } from '../../redux/actions/userActions';

const XiaomiEventLogin = ({ happeningName = 'XiaomiEvent2026', variant }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('xiaomiEvent');
    const pageWrapperClass = `${styles['page-wrapper']} ${variant ? styles[`page-wrapper--${variant}`] : ''}`;
    const [isRegistrationOpen, setIsRegistrationOpen] = useState(true);

    const [isValidName, setIsValidName] = useState(0);
    const [isValidCompany, setIsValidCompany] = useState(0);
    const [isValidEmail, setIsValidEmail] = useState(0);
    const [isValidPosition, setIsValidPosition] = useState(0);

    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [position, setPosition] = useState('');
    const [isRegistered, setIsRegistered] = useState(0);
    const [alreadyRegistered, setAlreadyRegistered] = useState(false);

    useEffect(() => {
        const ls = new SecureLS({ encodingType: 'aes' });
        const userInfoData = ls.get('userInfo');

        const attributes = {};
        attributes['anUserKey'] = userInfoData ? userInfoData.company.department[0].user[0].anUserKey : 0;
        attributes['acHappeningName'] = happeningName;

        const configRes = axiosinstance(attributes, '8224', 'happeningCheck');

        axios(configRes)
            .then((response) => {
                const { isOk, acMsg } = response.data.response;
                if (isOk === 1) return;
                // Rok za prijavu je na backendu, happeningCheck javlja kada je istekao
                if (acMsg === 'happeningDateExpirePareseError') {
                    setIsRegistrationOpen(false);
                } else {
                    setAlreadyRegistered(true);
                }
            })
            .catch((error) => {
                console.error('happeningCheck error:', error);
            });
    }, [happeningName]);

    const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

    const onChangeInput = (e) => {
        const { name: fieldName, value } = e.target;
        if (fieldName === 'inputName') setName(value);
        if (fieldName === 'inputCompany') setCompany(value);
        if (fieldName === 'inputEmail') setEmail(value);
        if (fieldName === 'inputPosition') setPosition(value);
    };

    const handleSubmit = () => {
        const validName = name.trim() !== '' ? 2 : 1;
        const validCompany = company.trim() !== '' ? 2 : 1;
        const validEmail = email.trim() === '' ? 1 : (validateEmail(email) ? 2 : 1);
        const validPosition = position.trim() !== '' ? 2 : 1;

        setIsValidName(validName);
        setIsValidCompany(validCompany);
        setIsValidEmail(validEmail);
        setIsValidPosition(validPosition);

        if (validName !== 2 || validCompany !== 2 || validPosition !== 2) {
            toast(<MessageInfoBox message="errorMissingOneOrMoreFields" type="0" />, { className: 'red-background' });
            return;
        }
        if (validEmail !== 2) {
            toast(<MessageInfoBox message="emailNotFoundError" type="0" />, { className: 'red-background' });
            return;
        }

        const payload = {
            acName: name,
            acCompany: company,
            acEmail: email,
            acOption1: position,
            acType: happeningName,
        };
        dispatch(happeningXiaomiEvent(payload)).then(res => {
            if (!res) {
                setIsRegistered(2);
                return;
            }
            if (res.isOk === 1) {
                setIsRegistered(1);
            } else {
                setIsRegistered(2);
            }
        }).catch((err) => {
            console.error('happeningXiaomiEvent error:', err);
        });
    };

    if (isRegistered === 1) {
        return (
            <div className={pageWrapperClass}>
                <div className={styles['bg-image']} />
                <div className={styles['form-card']}>
                    <div className={styles['logo-wrapper']}><img src="https://resource.ewe.rs/media/XiaomiEvent2026/Xiaomi_logo.png" alt="Xiaomi logo" className={styles['logo-img']} /></div>
                    <h1 className={styles['title']}>{t('successTitle')}</h1>
                    <p className={styles['subtitle']}>{t('successText')}</p>
                </div>
            </div>
        );
    }

    if (alreadyRegistered) {
        return (
            <div className={pageWrapperClass}>
                <div className={styles['bg-image']} />
                <div className={styles['form-card']}>
                    <div className={styles['logo-wrapper']}><img src="https://resource.ewe.rs/media/XiaomiEvent2026/Xiaomi_logo.png" alt="Xiaomi logo" className={styles['logo-img']} /></div>
                    <h1 className={styles['title']}>{t('alreadyTitle')}</h1>
                    <p className={styles['subtitle']}>{t('alreadyText')}</p>
                </div>
            </div>
        );
    }

    if (!isRegistrationOpen) {
        return (
            <div className={pageWrapperClass}>
                <div className={styles['bg-image']} />
                <div className={styles['form-card']}>
                    <div className={styles['logo-wrapper']}><img src="https://resource.ewe.rs/media/XiaomiEvent2026/Xiaomi_logo.png" alt="Xiaomi logo" className={styles['logo-img']} /></div>
                    <h1 className={styles['title']}>{t('expiredTitle')}</h1>
                    <p className={styles['subtitle']}>{t('expiredText')}</p>
                    <p className={styles['subtitle']}>{t('expiredThanks')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={pageWrapperClass}>
            <div className={styles['bg-image']} />
            <div className={styles['form-card']}>
                <div className={styles['logo-wrapper']}><img src="https://resource.ewe.rs/media/XiaomiEvent2026/Xiaomi_logo.png" alt="Xiaomi logo" className={styles['logo-img']} /></div>

                <h1 className={styles['title']}>{t('formTitle')}</h1>
                <p className={styles['subtitle']}>{t('formSubtitle')}</p>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputName">{t('labelName')}</label>
                    <input
                        id="inputName"
                        name="inputName"
                        type="text"
                        value={name}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidName === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputCompany">{t('labelCompany')}</label>
                    <input
                        id="inputCompany"
                        name="inputCompany"
                        type="text"
                        value={company}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidCompany === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputEmail">{t('labelEmail')}</label>
                    <input
                        id="inputEmail"
                        name="inputEmail"
                        type="email"
                        value={email}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidEmail === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputPosition">
                        {t('labelPosition')} <span className={styles['field-label--hint']}>{t('labelPositionHint')}</span>
                    </label>
                    <input
                        id="inputPosition"
                        name="inputPosition"
                        type="text"
                        value={position}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidPosition === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <button className={styles['submit-btn']} onClick={handleSubmit}>
                    {t('submit')}
                </button>
            </div>
        </div>
    );
};

// PublicRoute ne prosleđuje dodatne propse, pa MK event ima svoj omotač
export const XiaomiEventMkLogin = () => <XiaomiEventLogin happeningName="XiaomiEventMk2026" variant="mk" />;

export default XiaomiEventLogin;
